import React from "react";
import { observer } from "mobx-react";
import { PlatformCreateStore } from "../../store";
import { PlatformCreateForm } from "./PlatformCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PlatformCreateProps = {
  platformCreateStore: PlatformCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PlatformCreate: React.FC<PlatformCreateProps> = observer(
  ({ platformCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={platformCreateStore.isSaving} />
        <PlatformCreateForm
          platformCreateStore={platformCreateStore}
          nameError={platformCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            platformCreateStore.setNameValue(value);
          }}
          name={platformCreateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={platformCreateStore.isProcessing}
          onSave={() => platformCreateStore.saveNewPlatform()}
          onCancel={() => platformCreateStore.cancelNewPlatform()}
        />
        <ErrorDialog
          open={platformCreateStore.errorDialogOpened}
          title={platformCreateStore.errorTitle}
          description={platformCreateStore.errorDescription}
          onClose={() => platformCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
